#import "../../../../../../core-entity/widgets/email-sequences-widget/graphql/fragments/drip-progression-fragment.graphql"
#import "../../../../../../core-entity/widgets/email-sequences-widget/graphql/fragments/email-automation-statuses-fragment.graphql"
#import "../../../../../../core-entity/widgets/email-sequences-widget/graphql/fragments/email-sequence-fragment-sparse.graphql"
#import "../../../../../../core-entity/widgets/email-sequences-widget/graphql/fragments/queued-email-fragment-sparse.graphql"

query GetContactEmailSequenceData($contactId: ID!) {
    contact(id: $contactId) {
        id
        name
        dripProgressions {
            ...DripProgressionFragment
        }
        emailAutomationStatuses {
            ...EmailAutomationStatusesFragment
        }
        queuedEmails {
            id
            emailSequence {
                ...EmailSequenceFragmentSparse
            }
            ...QueuedEmailFragmentSparse
        }
    }
}
